import styled from 'styled-components';
import { HeaderTitle } from 'ui/pageHeader';
import { Box } from 'ui-beta/box';
import { body2, colors, fontWeights, H4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledSection = styled.section`
  ${body2}
  display: flex;
  align-content: flex-start;
  justify-content: flex-start;
  padding: ${spacing.double} 0;

  @media (width <= 1024px) {
    display: block;
    padding: ${spacing.base} 0;
  }

  & + & {
    border-top: ${colors.grey10};
  }
`;

export const SectionHeader = styled.div`
  flex: 0 0 ${spacing.x24};
  color: ${colors.grey60};
  padding-bottom: ${spacing.base};
  padding-right: ${spacing.double};
`;

export const SectionTitle = styled(H4)`
  font-weight: ${fontWeights.semiBold};
  && {
    margin-bottom: ${spacing.half};
  }
`;

export const StyledSectionContent = styled.div`
  flex: 1 1 auto;
`;

export const StyledBox = styled(Box)`
  width: 100%;
  background: ${colors.white};
  overflow: visible;
`;

export const StyledDetailsHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${spacing.threeQuarter};
  background: ${colors.grey5};
  width: 100%;
  min-height: ${pxToRem(50)};
  border-bottom: ${spacing.single} solid ${colors.grey15};
  color: ${colors.black};
`;

export const DetailsTitle = styled.div`
  position: absolute;
  left: ${spacing.threeQuarter};
  font-weight: ${fontWeights.semiBold};
`;

export const StyledHeaderTitle = styled(HeaderTitle)`
  display: flex;
  align-items: center;
  > *:first-child {
    margin-right: ${spacing.half};
  }
`;

export const StyledDL = styled.dl`
  display: grid;
  grid-template-columns: 1fr 3fr;
  justify-content: start;
  grid-gap: ${spacing.half};
  padding: ${spacing.base};
  padding-bottom: 0;
  dt {
    font-weight: ${fontWeights.bold};
  }
`;

export const StyledHeader = styled.div`
  color: ${colors.grey15};
  padding: ${pxToRem(10)};
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
